module.exports = __webpack_public_path__ + "static/media/myipo-logo.ba190adc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myipo-logo.svg
// module id = 8116
// module chunks = 0